import { render } from "./SynodicOrbitObjectsConfiguration.vue?vue&type=template&id=655d61e3"
import script from "./SynodicOrbitObjectsConfiguration.vue?vue&type=script&lang=js"
export * from "./SynodicOrbitObjectsConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__